"use client";

import React, { useEffect } from "react";
import Input from "../ui/input";
import PrimaryButton from "../ui/primary-button";
import { useActionState } from "react";
import { toast } from "sonner";
import IllustrationNewsletter from "../illustrations/illustration-newsletter";
import {
  create,
  NewsletterEmailOnlyErrors,
} from "../newsletter-email-only-actions";

const initialState: {
  status: string;
  errors?: NewsletterEmailOnlyErrors;
  message?: string;
} = { status: "" };

const SubmitButton = ({ isPending }: { isPending: boolean }) => {
  return (
    <PrimaryButton
      type="submit"
      size="md"
      color="orange-light"
      aria-label="submit newsletter form input"
      disabled={isPending}
    >
      Subscribe to Our Newsletter
    </PrimaryButton>
  );
};

const NewsletterFormLarge = () => {
  const [state, formAction, isPending] = useActionState(create, initialState);

  useEffect(() => {
    if (state?.message) {
      toast.error(state?.message);
    }
  }, [state]);

  return (
    <div className="flex w-full bg-secondary-500">
      {state.status === "success" ? (
        <div className="mx-auto flex w-full max-w-lg flex-col justify-between gap-6 px-4 py-8 md:gap-4 md:px-6 md:py-10 lg:flex-row lg:gap-2 lg:px-3 lg:py-11">
          <div className="flex flex-col justify-center gap-2 text-center lg:gap-4 lg:text-start">
            <h2 className="font-montserrat text-heading-4 text-primary-200 md:text-heading-3 lg:text-heading-2">
              Thank you for joining the Care Indeed Community!
            </h2>
            <p className="font-roboto text-body-1-300 text-white">
              You&apos;ll get the latest home care news, tips, and resources
              straight to your inbox.
            </p>
          </div>
          <div className="flex justify-center">
            <IllustrationNewsletter className="h-[96px] w-[260px] md:h-[136px] md:w-[370px] lg:h-[176px] lg:w-[478px]" />
          </div>
        </div>
      ) : (
        <form
          id="newsletter-resources-large-form"
          className="mx-auto grid w-full max-w-lg grid-cols-2 items-center gap-6 px-4 py-8 md:gap-10 md:px-6 md:py-10 lg:gap-2 lg:px-3 lg:py-16"
          aria-label="newsletter form large"
          action={formAction}
        >
          <div className="col-span-full flex flex-col gap-2 text-center lg:col-span-1 lg:gap-4 lg:text-start">
            <h2 className="font-montserrat text-heading-4 text-primary-200 md:text-heading-3 lg:text-heading-2">
              JOIN the 34,000+
              <br /> Care Indeed Community
            </h2>
            <p className="font-roboto text-body-1-300 text-white">
              Get the latest home care news, tips, and resources straight to
              your inbox.
            </p>
          </div>

          <div className="col-span-full flex w-full flex-col gap-4 lg:col-span-1">
            <Input
              id="newsletter-resources-large-form"
              name="email"
              placeholder="Email Address"
              aria-label="email"
              type="email"
              autoComplete="email"
              required
              className="text-center [&_input]:text-center [&_span]:text-[#FBE6E6]"
              error={
                Boolean(state.errors?.email?.length) ||
                Boolean(state.errors && Object.keys(state.errors).length > 0)
              }
              errorMessage={
                Boolean(state.errors?.email?.length)
                  ? state.errors?.email?.join(", ") || "Email is required"
                  : "Email is required"
              }
            />
            <SubmitButton isPending={isPending} />
          </div>
        </form>
      )}
    </div>
  );
};

export default NewsletterFormLarge;
